export let data = () => {
    return (
        {
            'menu': [
                {'title': 'صفحه اصلی', 'link': '', 'id': '1', 'child': null},

                {
                    'title': 'درباره ما', 'link': 'درباره-ما', 'id': '2', 'child': [
                        {
                            'title': 'ساختار', 'id': '2_1', 'child': [
                                {'title': 'هیئت امنا', 'link': 'هیئت-امنا', 'id': '2_1_1', 'child': null},
                                {'title': 'شورای عالی', 'link': 'شورای-عالی', 'id': '2_1_2', 'child': null},
                                {
                                    'title': 'ریاست', 'id': '2_1_3', 'child': [
                                        {'title': 'رئیس مرکز', 'link': 'رئیس-مرکز', 'id': '2_1_3_1', 'child': null},
                                        {
                                            'title': 'مشاوران مرکز',
                                            'link': 'مشاوران-مرکز',
                                            'id': '2_1_3_2',
                                            'child': null
                                        },
                                        // {
                                        //     'title': 'نیروی انسانی',
                                        //     'link': 'نیروی-انسانی',
                                        //     'id': '2_1_3_5',
                                        //     'child': null
                                        // }
                                    ]
                                },
                                {
                                    'title': 'معاونت ها', 'id': '2_1_4', 'child': [
                                        {
                                            'title': 'معاونت تحقیقات و فناوری', 'id': '2_1_4_1', 'child': [
                                                {
                                                    'title': 'معاون تحقیقات و فناوری',
                                                    'link': 'معاون-تحقیقات-و-فناوری',
                                                    'id': '2_1_4_1_1',
                                                    'child': null
                                                },
                                                {
                                                    'title': 'مدیر تحقیقات و فناوری',
                                                    'link': 'مدیر-تحقیقات-و-فناوری',
                                                    'id': '2_1_4_1_2',
                                                    'child': null
                                                }
                                            ]
                                        },
                                        {
                                            'title': 'معاونت توسعه مدیریت و منابع', 'id': '2_1_4_2', 'child': [
                                                {
                                                    'title': 'معاون',
                                                    'link': 'معاون-توسعه-مدیریت-و-منابع',
                                                    'id': '2_1_4_2_1',
                                                    'child': null
                                                },
                                                {
                                                    'title': 'مدیر امور اداری',
                                                    'link': 'مدیر-امور-اداری',
                                                    'id': '2_1_4_2_2',
                                                    'child': null
                                                },
                                                {
                                                    'title': 'مدیر مالی',
                                                    'link': 'مدیر-مالی',
                                                    'id': '2_1_4_2_3',
                                                    'child': null
                                                },
                                                {
                                                    'title': 'مسئول فناوری اطلاعات',
                                                    'link': 'مسئول-فناوری-اطلاعات',
                                                    'id': '2_1_4_2_4',
                                                    'child': null
                                                }
                                            ]
                                        },
                                    ]
                                },
                                {
                                    'title': 'گروه های راهبردی', 'id': '2_1_5', 'child': [
                                        {
                                            'title': 'گروه راهبردی نیازسنجی اولویت گذاری و نظارت',
                                            'link': 'گروه-راهبردی-نیازسنجی-اولویت-گذاری-و-نظارت',
                                            'id': '2_1_5_1',
                                            'child': null
                                        },
                                        {
                                            'title': 'گروه راهبردی مدیریت، ترجمان و کاربست دانش',
                                            'link': 'گروه-راهبردی-مدیریت،-ترجمان-و-کاربست-دانش',
                                            'id': '2_1_5_2',
                                            'child': null
                                        },
                                        {
                                            'title': 'گروه مدیریت داده، نوآوری و فناوری های آموزشی',
                                            'link': 'گروه-مدیریت-داده-نوآوری-و-فناوری-های-آموزشی',
                                            'id': '2_1_5_3',
                                            'child': null
                                        },
                                        {
                                            'title': 'گروه مطالعات سیاستی و آینده نگاری',
                                            'link': 'گروه-مطالعات-سیاستی-و-آینده-نگاری',
                                            'id': '2_1_5_4',
                                            'child': null
                                        },
                                    ]
                                },
                                {
                                    'title': 'هیئت علمی', 'id': '2_1_6', 'child': [
                                        {
                                            'title': 'دکتر مریم حسینی',
                                            'link': 'دکتر-مریم-حسینی',
                                            'id': '2_1_6_1',
                                            'child': null
                                        },
                                        {
                                            'title': 'دکتر مجید حیدری',
                                            'link': 'دکتر-مجید-حیدری',
                                            'id': '2_1_6_2',
                                            'child': null
                                        },
                                        {
                                            'title': 'دکتر محمد کیاسالار',
                                            'link': 'دکتر-محمد-کیاسالار',
                                            'id': '2_1_6_3',
                                            'child': null
                                        },
                                    ]
                                },
                            ]
                        },
                        {
                            'title': 'رسالت', 'id': '2_2', 'child': [
                                {'title': 'اهداف', 'link': 'اهداف', 'id': '2_2_1', 'child': null},
                                {'title': 'ماموریت ها', 'link': 'ماموریت-ها', 'id': '2_2_2', 'child': null},
                            ]
                        },
                        {
                            'title': 'تاریخچه', 'id': '2_3', 'child': [
                                {'title': 'تاریخچه', 'link': 'تاریخچه', 'id': '2_3_1', 'child': null},
                                {'title': 'روسا', 'link': 'روسا', 'id': '2_3_2', 'child': null},
                            ]
                        },
                    ]
                },
                {
                    'title': 'کلان پروژه ها / دانشنامه ها', 'id': '2_4', 'child': [
                        {
                            'title': 'دانشنامه نصر در حوزه مرجعیت علمی',
                            'link': 'دانشنامه-نصر-در-حوزه-مرجعیت-علمی',
                            'id': '2_4_1',
                            'child': null
                        },
                        {
                            'title': 'دانشنامه نصر در حوزه دانشگاه حکمت بنیان',
                            'link': 'دانشنامه-نصر-در-حوزه-دانشگاه-حکمت-بنیان',
                            'id': '2_4_2',
                            'child': null
                        },
                        {'title': 'دانشگاه نوآور و کارآفرین', 'link': 'دانشگاه-نوآور-و-کارآفرین', 'id': '2_4_3', 'child': null},
                    ]
                },
                {
                    'title': 'فراخوان ها و گرنت ها', 'id': '2_5', 'child': [
                        {'title': 'فراخوان ها و گرنت ها', 'link': 'فراخوان-ها-و-گرنت-ها', 'id': '2_5_1', 'child': null},
                        {'title': 'فرم ها و فرایندها', 'link': 'فرم-ها-و-فرایندها', 'id': '2_5_5', 'child': null},
                        {'title': 'گزارش ها', 'link': 'گزارش-ها', 'id': '2_5_7', 'child': null},
                        {'title': 'راهنمای ثبت طرح', 'link': 'راهنمای-ثبت-طرح', 'id': '2_5_6', 'child': null},
                    ],
                },
                {
                    'title': 'واحدهای تخصصی', 'id': '2_12', 'child': [
                        {'title': 'تحلیل سیاستی', 'link': 'تحلیل-سیاستی', 'id': '2_12_1', 'child': null},
                        {
                            'title': 'مدیریت و ترجمان دانش',
                            'link': 'مدیریت-و-ترجمان-دانش',
                            'id': '2_12_2',
                            'child': null
                        },
                        {
                            'title': 'آموزش سلامت',
                            'link': 'آموزش--سلامت',
                            'id': '2_12_3',
                            'child': null
                        },
                        {
                            'title': 'آموزش و پرورش',
                            'link': 'آموزش-و-پرورش',
                            'id': '2_12_4',
                            'child': null
                        },
                        {
                            'title': 'کمیته اخلاق',
                            'link': 'کمیته-اخلاق',
                            'id': '2_12_5',
                            'child': null
                        },
                    ]
                },
                {
                    'title': 'محصولات', 'id': '2_6', 'child': [
                        {'title': 'محصولات آموزشی', 'link': 'محصولات-آموزشی', 'id': '2_6_4', 'child': null},
                        {'title': 'محصولات سیاستی', 'link': 'محصولات-سیاستی', 'id': '2_6_1', 'child': null},
                        {
                            'title': 'محصولات منتج از طرح ها',
                            'link': 'محصولات-منتج-از-طرح-ها',
                            'id': '2_6_2',
                            'child': null
                        },
                        {
                            'title': 'محتواهای چندرسانه ای', 'link': 'محتواهای-چندرسانه-ای', 'id': '2_6_3', 'child': [
                                {'title': 'گزارش تصویری', 'link': 'گزارش-تصویری', 'id': '2_6_3_1', 'child': null},
                                {'title': 'پادکست', 'link': 'پادکست', 'id': '2_6_3_2', 'child': null},
                                {
                                    'title': 'فیلم', 'id': '2_9_3', 'child': [
                                        {'title': 'مسیحادم', 'link': 'مسیحادم', 'id': '2_6_3_2_1', 'child': null},
                                        {'title': 'نوآورانه', 'link': 'نوآورانه', 'id': '2_6_3_2_2', 'child': null},
                                    ]
                                },
                            ]
                        },
                    ]
                },
                {
                    'title': 'سامانه ها', 'id': '2_7', 'child': [
                        {'title': 'کایپر', 'link': '/rms.nasrme.ac.ir/', 'id': '2_7_1', 'child': null},
                        {'title': 'مرجعیت', 'link': '/ssms.nasrme.ac.ir/', 'id': '2_7_2', 'child': null},
                    ]
                },
                {'title': 'اخبار', 'link': 'آرشیو-اخبار', 'id': '2_8', 'child': null},
                {'title': 'ارتباط با ما', 'link': 'ارتباط-با-ما', 'id': '2_11', 'child': null}

            ]
        }
    )
}